import { useOutletContext } from "react-router";

import { ExistingDestination, useDestinationVendors } from "@prequel/react";
import { Badge, BadgeColor, Table } from "@prequel/shared-components";

import VendorLogo from "@/components/VendorLogo";
import { env } from "@/env";
import { getReadableLastSuccessfulSync, sortByLastSuccessfulSync } from "@/types";
import { getReadableVendor, getVendorLogoUrl } from "@/types/common";

const SuccessesTable = () => {
  const { successDestinations } = useOutletContext<{
    successDestinations?: ExistingDestination[];
  }>();
  const destinations = successDestinations;
  const destinationVendors = useDestinationVendors(env.VITE_APP_API_SERVER);

  // copy the array before sorting because the array is frozen
  const rows = [...(destinations || [])].sort(sortByLastSuccessfulSync).map((destination) => ({
    id: destination.id,
    to: `/destinations/${destination.id}`,
    cells: [
      {
        value: destination.name,
      },
      {
        value: (
          <div className="flex items-center">
            <VendorLogo logo_url={getVendorLogoUrl(destination.vendor, destinationVendors || [])} />
            {getReadableVendor(destination.vendor, destinationVendors || [])}
          </div>
        ),
      },
      {
        value: (
          <Badge
            color={destination.last_completed_transfer?.status == "SUCCESS" ? BadgeColor.GREEN : BadgeColor.RED}
            text={destination.last_completed_transfer?.status ?? "UNKNOWN"}
          />
        ),
      },
      {
        value: destination.last_completed_transfer?.rows_transferred.toLocaleString(),
      },

      {
        value: (
          <div className="text-gray-500">
            {getReadableLastSuccessfulSync(destination.last_completed_transfer?.ended_at)}
          </div>
        ),
      },
    ],
  }));

  const columns = ["Destination Name", "Vendor", "Status", "Rows Transferred", "Last Successful Sync"];

  return <Table columns={columns} rows={rows || []} footer={rows ? `${rows.length} successful transfers` : ""} />;
};

export default SuccessesTable;
